import React from "react";
import HeroImage from '../Common/Hero_Image';

const Hero = (props) => (
  <div className="agency-about-hero">
    <section className="container">
      <div className="row">
          <div className="hero-text">
            <p className="customFadeInUp">
            We envision a world where managing household finances is collaborative, and couples work as a team. 
            </p>
          </div>
        </div>
    </section>
    <HeroImage imageSharp={props.heroImage} />
  </div>
);

export default Hero;



// WEBPACK FOOTER //
// ./src/components/About/Hero.jsx